import React, { useState } from "react";
import { postApi } from "../../hooks/Api";
import { toast } from "react-toastify";

function AppointmentForm() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    date: "",
    treatment: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await postApi("/mail/contact", formData);
    if (response.success) {
      toast.success(response.message);
      setFormData({
        name: "",
        phone: "",
        email: "",
        date: "",
        treatment: "",
        message: "",
      });
    } else {
      toast.error(response.message);
    }
  };

  return (
    <section id="appointment" className="py-20 bg-neutral-900">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16 animate__animated animate__fadeInUp">
            <h2 className="text-3xl md:text-4xl text-white mb-4 font-bold font-poppins">
              Book an Appointment
            </h2>
            <p className="text-gray-300 font-normal font-poppins">
              Schedule a consultation with Dr. Anoop Choudhary
            </p>
          </div>

          <form
            className="space-y-6 animate__animated animate__fadeInUp"
            onSubmit={handleSubmit}
          >
            <div className="grid md:grid-cols-2 gap-6">
              {/* Full Name */}
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-300 mb-2 font-poppins"
                >
                  Full Name*
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 font-poppins bg-neutral-800 border border-neutral-700 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-white placeholder-gray-400"
                  placeholder="Enter your full name"
                />
              </div>

              {/* Phone */}
              <div>
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-gray-300 mb-2 font-poppins"
                >
                  Phone Number*
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  maxLength={10}
                  minLength={10}
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full font-poppins px-4 py-3 bg-neutral-800 border border-neutral-700 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-white placeholder-gray-400"
                  placeholder="Enter your phone number"
                />
              </div>

              {/* Email */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-300 mb-2 font-poppins"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 font-poppins py-3 bg-neutral-800 border border-neutral-700 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-white placeholder-gray-400"
                  placeholder="Enter your email address"
                />
              </div>

              {/* Date */}
              <div>
                <label
                  htmlFor="date"
                  className="block text-sm font-medium text-gray-300 mb-2 font-poppins"
                >
                  Preferred Date*
                </label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  required
                  min={new Date().toISOString().split("T")[0]}
                  value={formData.date}
                  onChange={handleChange}
                  className="w-full font-poppins px-4 py-3 bg-neutral-800 border border-neutral-700 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-white placeholder-gray-400"
                />
              </div>
            </div>

            {/* Treatment Type */}
            <div>
              <label
                htmlFor="treatment"
                className="block text-sm font-medium text-gray-300 mb-2 font-poppins"
              >
                Treatment Type*
              </label>
              <select
                id="treatment"
                name="treatment"
                required
                value={formData.treatment}
                onChange={handleChange}
                className="w-full px-4 py-3 font-poppins bg-neutral-800 border border-neutral-700 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-white placeholder-gray-400"
              >
                <option className="font-poppins" value="">
                  Select treatment type
                </option>
                <option className="font-poppins" value="skin">
                  Skin Treatment
                </option>
                <option className="font-poppins" value="hair">
                  Hair Treatment
                </option>
                <option className="font-poppins" value="pediatric">
                  Pediatric Care
                </option>
                <option className="font-poppins" value="chronic">
                  Chronic Diseases
                </option>
                <option className="font-poppins" value="womens">
                  Women's Health
                </option>
                <option className="font-poppins" value="mental">
                  Mental Health
                </option>
              </select>
            </div>

            {/* Message */}
            <div>
              <label
                htmlFor="message"
                className="block text-sm font-medium text-gray-300 mb-2 font-poppins"
              >
                Additional Information
              </label>
              <textarea
                id="message"
                name="message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                className="w-full font-poppins px-4 py-3 bg-neutral-800 border border-neutral-700 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-white placeholder-gray-400"
                placeholder="Please provide any additional information about your condition"
              ></textarea>
            </div>

            {/* Submit Button */}
            <div className="text-center">
              <button
                type="submit"
                className="font-poppins bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-3 rounded-full transition-colors inline-flex items-center"
              >
                <span>Book Appointment</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 ml-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default AppointmentForm;
